module.exports = __webpack_public_path__ + "assets/remove-string.c995675c.svg";